import { createAction, props } from '@ngrx/store';
import { IDisposition, IApiResponse, IDispositionListResponse,IListDispositionRequest,IDispositionListFilter, IDispositionNameResponse, ICreateDispositionRequest, ICreateDispositionResponse } from '../../models/disposition.model';
import { WritableSignal } from '@angular/core';

// Load Dispositions
export const loadDispositions = createAction(
  '[Disposition] Load Dispositions',
  // props<{ filter?: IDispositionListFilter; pagination?: IListDispositionRequestParams }>() // Use your interfaces here
);

const loadDispositionsSuccess = createAction(
  '[Disposition] Load Dispositions Success',
  props<{ response: IDispositionListResponse,filter?: IDispositionListFilter; }>()
);


const loadDispositionsFailure = createAction(
  '[Disposition] Load Dispositions Failure',
  props<{ error: string }>()
);

// Create Disposition
const createDisposition = createAction(
  '[Disposition] Create Disposition',
  props<{ disposition: ICreateDispositionRequest}>()
);

const createDispositionSuccess = createAction(
  '[Disposition] Create Disposition Success',
  props<{ response: IApiResponse<IDisposition | ICreateDispositionResponse > }>()
);

const createDispositionFailure = createAction(
  '[Disposition] Create Disposition Failure',
  props<{ error: string }>()
);

// Get Single Disposition
const loadSingleDisposition = createAction(
  '[Disposition] Load Single Disposition',
  props<{ id: number }>()
);

const loadSingleDispositionSuccess = createAction(
  '[Disposition] Load Single Disposition Success',
  props<{ response: IApiResponse<IDisposition> }>()
);

const loadSingleDispositionFailure = createAction(
  '[Disposition] Load Single Disposition Failure',
  props<{ error: string }>()
);

// Update Disposition
const updateDisposition = createAction(
  '[Disposition] Update Disposition',
  props<{ id: number; disposition: Partial<IDisposition>, closeModalSignal: WritableSignal<boolean> }>()
);

const updateDispositionSuccess = createAction(
  '[Disposition] Update Disposition Success',
  props<{ response: IApiResponse<IDisposition> }>()
);

const updateDispositionFailure = createAction(
  '[Disposition] Update Disposition Failure',
  props<{ error: string }>()
);

// Delete Disposition
const deleteDisposition = createAction(
  '[Disposition] Delete Disposition',
  props<{ id: number, closeModalSignal: WritableSignal<boolean> }>()
);

const deleteDispositionSuccess = createAction(
  '[Disposition] Delete Disposition Success',
  props<{ id: number; message: string }>()
);

const deleteDispositionFailure = createAction(
  '[Disposition] Delete Disposition Failure',
  props<{ error: string }>()
);

// Toggle Status
const toggleDispositionStatus = createAction(
  '[Disposition] Toggle Status',
  props<{ id: number }>()
);

const toggleDispositionStatusSuccess = createAction(
  '[Disposition] Toggle Status Success',
  props<{ response: IApiResponse<{ updatedDisposition: IDisposition }> }>()
);

const toggleDispositionStatusFailure = createAction(
  '[Disposition] Toggle Status Failure',
  props<{ error: string }>()
);

const setDispositionQueryParams = createAction(
  '[Disposition] Set Query Params',
  props<IListDispositionRequest>()
);

const changeDispositionStatus = createAction(
  '[Disposition] Change Disposition Status',
  props<{ id: number }>()
);

const changeDispositionStatusSuccess = createAction(
  '[Disposition] Change Disposition Status Success'
);
const changeDispositionStatusFailure = createAction(
  '[Disposition] Change Disposition Status Failure',
  props<{ error: string }>()
);

// Load Disposition Names
export const loadDispositionNames = createAction(
  '[Disposition] Load Disposition Names'
);

export const loadDispositionNamesSuccess = createAction(
  '[Disposition] Load Disposition Names Success',
  props<{ response: IApiResponse<IDispositionNameResponse> }>()
);

export const loadDispositionNamesFailure = createAction(
  '[Disposition] Load Disposition Names Failure',
  props<{ error: string }>()
);

// Load All Status Disposition Names
export const loadAllStatusDispositionNames = createAction(
  '[Disposition] Load AllStatus Disposition Names'
);

export const loadAllStatusDispositionNamesSuccess = createAction(
  '[Disposition] Load AllStatus Disposition Names Success',
  props<{ response: IApiResponse<IDispositionNameResponse> }>()
);

export const loadAllStatusDispositionNamesFailure = createAction(
  '[Disposition] Load AllStatus Disposition Names Failure',
  props<{ error: string }>()
);

const bulkDeleteDispositions = createAction(
  '[Disposition] Bulk Delete Dispositions',
  props<{
    ids: (number | undefined)[];
    closeModalSignal: WritableSignal<boolean>;
  }>()
);

const bulkDeleteDispositionsSuccess = createAction(
  '[Disposition] Bulk Delete Dispositions Success',
  props<{ ids: (number | undefined)[] }>()
);

const bulkDeleteDispositionsFailure = createAction(
  '[Disposition] Bulk Delete Dispositions Failure',
  props<{ error: string }>()
);
const clearSingleDisposition = createAction('[Disposition] Clear Single disposition');


export const DispositionActions = {
  loadDispositions,
  loadDispositionsSuccess,
  loadDispositionsFailure,
  loadSingleDisposition,
  loadSingleDispositionSuccess,
  loadSingleDispositionFailure,
  createDisposition,
  createDispositionSuccess,
  createDispositionFailure,
  updateDisposition,
  updateDispositionSuccess,
  updateDispositionFailure,
  deleteDisposition,
  deleteDispositionSuccess,
  deleteDispositionFailure,
  toggleDispositionStatus,
  toggleDispositionStatusSuccess,
  toggleDispositionStatusFailure,
  setDispositionQueryParams,
  changeDispositionStatus,
  changeDispositionStatusSuccess,
  changeDispositionStatusFailure,
  loadDispositionNames,
  loadDispositionNamesSuccess,
  loadDispositionNamesFailure,
  loadAllStatusDispositionNames,
  loadAllStatusDispositionNamesSuccess,
  loadAllStatusDispositionNamesFailure,
  bulkDeleteDispositions,
  bulkDeleteDispositionsSuccess,
  bulkDeleteDispositionsFailure,
  clearSingleDisposition,
};
